import { useState, useEffect } from 'react'
import superagent from 'superagent'
import { backendUrl } from '../consts'

const useNestingRules = () => {
  const [nestingData, setNestingData] = useState({})
  const [accNestingdata, setAccNestingdata] = useState({})
  const [version, setVersion] = useState(undefined)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let mounted = true

    superagent
      .get(`${backendUrl}/nesting-rules/frontend-maps`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .then((res) => {
        if (!mounted) return
        const data = res.body || {}
        setNestingData(data.nestingData || {})
        setAccNestingdata(data.accNestingdata || {})
        setVersion(data.version)
        setLoaded(true)
      })
      .catch((err) => {
        if (!mounted) return
        console.warn('Failed to fetch nesting rules from API, using empty data', err)
        setLoaded(true)
      })

    return () => {
      mounted = false
    }
  }, [])

  return { nestingData, accNestingdata, version, loaded }
}

export default useNestingRules
